import React from 'react';

import DailyListTable from '../components/DailyListTable';
import ModalItem from '../components/ModalItem';
import { getItemChanges } from "../utils/items";
import { amsterdamToday } from "../utils/time";
import useWsEvents from "../hooks/useWsEvents";
import { getCorrectOrder, getDailyList, setProp } from "../api/wsApi";


function ToGoodToGo() {
    const [data, setData] = React.useState({});
    const [correctOrder, setCorrectOrder] = React.useState([]);
    const [processedData, setProcessedData] = React.useState([]);
    const [showModal, setShowModal] = React.useState(false);
    const [selectedItem, setSelectedItem] = React.useState(null);


    const fetchDailyList = async () => {
        getDailyList()
            .then((data) => {
                const sortedData = {};
                data.forEach(element => {
                    sortedData[element.id] = element;
                });
                setData(sortedData);
            })
            .catch((err) => {
                console.log("Error fetching daily list", err);
            });
    }

    const updateDataItem = (item) => {
        const originalItem = data[item.id];
        const changes = getItemChanges(item, originalItem);
        const requests = changes.map(({ key, value }) => setProp(key, item.id, value));
        Promise.all(requests).then(() => {
            fetchDailyList();
            fetchCorrectOrder();
        });
    };

    const fetchCorrectOrder = async () => {
        getCorrectOrder()
            .then((data) => {
                setCorrectOrder(data);
            })
            .catch((err) => {
                console.log("Error fetching correct order", err);
            });
    }

    const openBeheer = (id) => {
        setSelectedItem(data[id]);
        setShowModal(true);
    }

    const quickAction = (item) => {
    }

    React.useEffect(() => {
        fetchDailyList();
        fetchCorrectOrder();
    }, []);

    useWsEvents((message) => {
        switch (message.event) {
            case "dailyListUpdated":
                fetchDailyList();
                break;
            case "correctOrderUpdated":
                fetchCorrectOrder();
                break;
            default:
                break;
        }
    });


    React.useEffect(() => {
        const tmpData = []

        if (data && correctOrder) {
            for (const meter of correctOrder) {
                for (const id of meter) {
                    if (data[id]) {
                        while (tmpData.length <= data[id].meter - 1) {
                            tmpData.push([]);
                        }

                        const date = data[id].edited?data[id].new_date:data[id].date;

                        if (date == null) continue;

                        const dateParts = date.split('-');
                        //console.log("date", date);
                        const dateObj = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                        dateObj.setHours(0, 0, 0, 0);
                        const today = amsterdamToday();
                        today.setHours(0, 0, 0, 0);

                        //console.log(dateObj, today);
                        //console.log(dateObj == today);

                        if (dateObj <= today && dateObj >= today) {
                            tmpData[data[id].meter - 1].push({...data[id]});
                        }
                    }
                }
            }
        }
        //console.log("tmpData", tmpData);
        setProcessedData(tmpData);
    }, [data, correctOrder]);


    return (
        <div>
            {processedData && <DailyListTable meters={processedData} openBeheer={openBeheer} quickAction={quickAction} newDate={() => {}} /> }



            {showModal && <ModalItem item={selectedItem} onClick={
                () => {
                    setShowModal(false);
                }
            } updateDataItem={updateDataItem} fetchData={fetchDailyList} />}
        </div>
    );
}

export default ToGoodToGo;
